export enum EntryTypeEnum {
  Entry = 'Entry',
  Leave = 'Leave'
}
